import useTenant from '@/hooks/useTenant'
import { Avatar, CardMedia, Stack, Typography } from '@mui/material'
import React from 'react'

export type ItemDetailMediaProps = {
  itemName: string
  itemImage?: string
  vendorName: string
  vendorLogo?: string
}

const ItemDetailMedia: React.FC<ItemDetailMediaProps> = ({
  itemName,
  itemImage,
  vendorName,
  vendorLogo,
}) => {
  const tenant = useTenant()
  return (
    <CardMedia
      sx={{
        minHeight: { md: '300px', xs: '200px' },
        minWidth: '100%',
        height: { md: '300px', xs: '200px' },
        width: '100%',
      }}
      title={itemName}
      image={itemImage || tenant.marketing.assets?.placeholder || ''}
    >
      <Stack height="100%" width="100%" direction="column-reverse">
        <Stack spacing={2} padding={1} alignItems="center" direction="row-reverse">
          {vendorLogo ? (
            <Avatar sx={{ width: 50, height: 50 }} alt={vendorName} src={vendorLogo} />
          ) : null}
          <Typography
            sx={{ textShadow: '0px 0px 3px black' }}
            color="inverted.main"
            variant="subtitle2"
          >
            Freshly prepared by {vendorName}
          </Typography>
        </Stack>
      </Stack>
    </CardMedia>
  )
}

export default ItemDetailMedia
